module.exports = __webpack_public_path__ + "images/stickers/pete-busy.ef0eb59b05378f25bb0c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-busy.png
// module id = o/87
// module chunks = 12